import * as React from 'react';
import * as classNames from 'classnames';
import photoStyle from './Photo.less';

interface PhotoCaptureProps extends React.ClassAttributes<any> {
    width: number;
    height: number;
    widthCapture?: number;
    heightCapture?: number;
    facingMode: string;
    onCapture(fotob64: string): void;
    onCancel(): void;
}

export interface PhotoCaptureState {
    videoSrc: MediaStream;
    orientationchanged: string;
    flashOn: boolean;
    nativeW: number;
    nativeH: number;
}

export class PhotoCapture extends React.Component<PhotoCaptureProps, PhotoCaptureState> {
    constructor(props: any) {
        super(props);
        this.state = {
            videoSrc: null,
            orientationchanged: 'no',
            flashOn: false,
            nativeW: 0,
            nativeH: 0
        };

        this.initCamera = this.initCamera.bind(this);
        this.handleVideo = this.handleVideo.bind(this);
        this.onCapabilitiesReady = this.onCapabilitiesReady.bind(this);
    }

    private videoElement: any;
    private canvasElement: any;
    private track: any;

    componentDidMount() {
        this.initCamera();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevState.flashOn !== this.state.flashOn) {
            this.onCapabilitiesReady(this.state.flashOn);
        }
    }

    componentWillUnmount() {
        if (this.track) {
            this.onCapabilitiesReady(false);
            this.track.stop();
        }
        if (this.videoElement) {
            this.videoElement.pause();
            if (this.videoElement.srcObject != null) {
                const tracks = this.videoElement.srcObject.getTracks();
                tracks.forEach((track: any) => track.stop());
                this.videoElement.srcObject = null;
            }
        }
    }

    initCamera() {
        const heightCapture = this.props.heightCapture ? this.props.heightCapture : this.props.height;
        const widthCapture = this.props.widthCapture ? this.props.widthCapture : this.props.width;
        const that = this;
        window.addEventListener('orientationchange', function () {
            that.orientationChanged();
        });
        if (!navigator.mediaDevices) {
            alert('Kamera ist nicht verfügbar. Öffnen Sie bitte diese Seite mit HTTPS!');
            return;
        }
        navigator.mediaDevices.getUserMedia(
            {
                video: {
                    width: widthCapture,
                    height: heightCapture,
                    facingMode: 'environment'
                }
            }
        ).then((stream) => { this.handleVideo(stream, this.state.flashOn); });
    }

    orientationChanged() {
        const orientationchanged = 'changed';
        // alert('orientationchanged obviously');
        // this.setState({orientationchanged});
        this.props.onCancel();
    }

    handleVideo(stream: MediaStream, flashOn: boolean) {
        const that = this;
        // console.log(flashOn, stream);
        this.setState({ videoSrc: stream });
        this.videoElement.srcObject = stream;
        this.track = stream.getVideoTracks()[0];
        this.videoElement.onloadedmetadata = function () {
            that.videoElement.play();
            window.setTimeout(() => {
                const nativeH = that.videoElement.videoHeight;
                const nativeW = that.videoElement.videoWidth;
                that.setState({ nativeH, nativeW });
                that.onCapabilitiesReady(flashOn);
            }, 500);
        };
    }

    onCapabilitiesReady(flashOn: boolean) {
        const track = this.track;
        // console.log(track);
        if (track && typeof track.getCapabilities === 'function') {
            const capabilities = track.getCapabilities();
            if (capabilities && capabilities.torch) {
                const constraints: any = {
                    advanced: [{ torch: flashOn }]
                };
                track.applyConstraints(constraints).catch((e: any) => console.log(e));
            }
        }
    }

    capture() {
        // const heightCapture = this.props.heightCapture ? this.props.heightCapture : this.props.height;
        // const widthCapture = this.props.widthCapture ? this.props.widthCapture : this.props.width;
        const heightCapture = this.state.nativeH ? this.state.nativeH :
            this.props.heightCapture ? this.props.heightCapture : this.props.height;
        const widthCapture = this.state.nativeW ? this.state.nativeW :
            this.props.widthCapture ? this.props.widthCapture : this.props.width;
        const context = this.canvasElement.getContext('2d');

        // if (window.screen.width >= window.screen.height) {
        //     context.drawImage(this.videoElement, 0, 0, widthCapture, heightCapture);
        // } else {
        //     this.canvasElement.setAttribute('width', heightCapture);
        //     this.canvasElement.setAttribute('height', widthCapture);
        //     context.drawImage(this.videoElement, 0, 0, heightCapture, widthCapture);
        // }
        context.drawImage(this.videoElement, 0, 0, widthCapture, heightCapture);

        const dataURL = this.canvasElement.toDataURL();
        this.props.onCapture(dataURL);
    }

    onCancel() {
        this.props.onCancel();
    }

    videoError() { }

    render() {
        const heightShow = this.props.heightCapture ? this.props.heightCapture : this.props.height;
        const widthShow = this.props.widthCapture ? this.props.widthCapture : this.props.width;

        const heightCapture = this.state.nativeH ? this.state.nativeH :
            this.props.heightCapture ? this.props.heightCapture : this.props.height;
        const widthCapture = this.state.nativeW ? this.state.nativeW :
            this.props.widthCapture ? this.props.widthCapture : this.props.width;

        const video = (<video
            id='video'
            style={{
                maxWidth: window.screen.width,
                maxHeight: window.screen.availHeight - 130,
                margin: '-20px auto 0 auto'
            }}
            autoPlay={true}
            ref={(input) => {
                this.videoElement = input;
            }
            }>
        </video>);

        const canvas = (<canvas
            className={photoStyle.photoCanvas}
            id='canvas'
            width={widthCapture}
            height={heightCapture}
            ref={(input) => this.canvasElement = input} />);

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <div>
                    <div>{video}</div>
                    <div>{canvas}</div>
                </div>
                <div className={photoStyle.icondiv}>
                    <img
                        className={photoStyle.iconsvg}
                        src={this.state.flashOn ? 'src/icons/flash-on.svg' : 'src/icons/flash-off.svg'}
                        onClick={() => {
                            this.setState({ flashOn: !this.state.flashOn });
                        }}
                    />
                    <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icon-icons-com_blende.png'
                        onClick={() => this.capture()}
                    />
                    <img
                        className={photoStyle.iconsvg}
                        src='src/icons/icons8-cancel.svg'
                        onClick={() => this.onCancel()}
                    />
                </div>
            </div>
        );
    }
}
